import {
  pinPickupIcon,
  pinDropIconesktop,
  pinDropIcon,
  pinPickupIconDesktop,
} from '@porterin/component-library/src/location-accuracy/store/LocationAccuracyStore';
import { useLocation } from '@porterin/component-library/src/location-accuracy/contexts/LocationContext';
import Image from 'next/image';
import React from 'react';

export const MapPinCmpDesktop: React.FC = () => {
  const { state } = useLocation();
  const mapPinIcon = state.waypoint === 'Pickup' ? pinPickupIcon : pinDropIcon;

  const mapPinTooltip =
    state.waypoint === 'Pickup' ? pinPickupIconDesktop : pinDropIconesktop;

  return (
    <div>
      <Image
        className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-full -mt-[0.6rem] pointer-events-none"
        src={mapPinTooltip}
        height={41.0}
        width={212.0}
        alt={'Map Pin Icon'}
      />
      <div
        data-testid="map-pin"
        className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none"
      >
        <Image
          src={mapPinIcon}
          height={50.0}
          width={50.0}
          alt={'Map Pin Icon'}
        />
      </div>
    </div>
  );
};
